/**
 * @generated SignedSource<<5ce5b22d1bcc237c51f9a0c31410530f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteCustomFieldDropdownOptionConfirmationModal_viewer$data = {
  readonly customFieldDefinition: {
    readonly options?: ReadonlyArray<{
      readonly id: string;
      readonly displayName: string;
      readonly isUsed: boolean;
      readonly usedCount: number | null;
    }>;
  } | null;
  readonly " $fragmentType": "DeleteCustomFieldDropdownOptionConfirmationModal_viewer";
};
export type DeleteCustomFieldDropdownOptionConfirmationModal_viewer$key = {
  readonly " $data"?: DeleteCustomFieldDropdownOptionConfirmationModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteCustomFieldDropdownOptionConfirmationModal_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomFieldDropdownOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUsed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usedCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "customFieldId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteCustomFieldDropdownOptionConfirmationModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "customFieldId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "customFieldDefinition",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "DropdownCustomField",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v0/*: any*/),
          "type": "MultiSelectCustomField",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "c0c3f24fd91da96b089e0937285b6658";

export default node;
